import { Directive, type AfterViewInit, inject } from '@angular/core';
import { MatSort } from '@angular/material/sort';

@Directive({
  selector: '[appTwoStateSort]',
  standalone: false
})
export class TwoStateSortDirective implements AfterViewInit {
  private matSort = inject(MatSort);

  ngAfterViewInit(): void {
    // Prevent the "none" state — only asc/desc will toggle
    this.matSort.sortChange.subscribe(() => {
      if (this.matSort.direction === '') {
        this.matSort.direction = 'asc';
      }
    });
  }
}
